import { render, staticRenderFns } from "./UkrposhtaTableMobile.vue?vue&type=template&id=7c2fb3f2&scoped=true"
import script from "./UkrposhtaTableMobile.vue?vue&type=script&lang=js"
export * from "./UkrposhtaTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2fb3f2",
  null
  
)

export default component.exports